<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import {ApplicationHelper} from "../../../helpers/ApplicationHelper";

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
  components: { Doughnut },
  props: {
    /**
     * Example of data format:
     * {
     *   labels: ['String1', 'String2', 'String3', 'String4'],
     *   datasets: [
     *     {
     *       backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
     *       data: [40, 20, 80, 10]
     *     }
     *   ]
     * }
     */
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {}
    },
    noDataMessage: {
      type: String,
      default: "Not enough data to report on."
    },
    maintainAspectRatio: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: 'bottom'
    },
    hideLabels: {
      type: Boolean,
      default: false
    },
    formatAsMoney: {
      type: Boolean,
      default: false
    },
    hideTooltip: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {};
  },
  data() {
    // Capture the component context for callback
    // Context gets confused in the chart
    const self = this;

    return {
      defaultOptions: {
        maintainAspectRatio: this.maintainAspectRatio,
        cutout: '70%',
        plugins: {
          legend: {
            display: !this.hideLabels,
            position: this.labelPosition,
            labels: {
              usePointStyle: true
            }
          },
          tooltip: {
            enabled: !self.hideTooltip,
            callbacks: {
              label: function(tooltipItem) {
                if(self.formatAsMoney) {
                  return ApplicationHelper.formatMoney(tooltipItem.raw.toString(), true);
                } else {
                  return tooltipItem.raw.toString();
                }
              }
            }
          }
        }
      }
    };
  },
  computed: {},
};
</script>

<template>
  <template v-if="data['datasets'].length > 0">
    <Doughnut
      :data="data"
      :options="(options) ? options : defaultOptions"
    />
  </template>
  <template v-else>
    <p class="no-data-message">
      {{ noDataMessage }}
    </p>
  </template>
</template>

<style lang="scss"></style>
